import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { DashboardService } from "../../dashboard.service";
import { DashboardStore } from "../../dashboard.store";
import { GenericDrawerService } from "../../drawer/global-drawer.service";
import { WorkspacesService } from "../../main/accountant/workspaces.service";
import { RealTimeService } from "../../main/common/notifications/real-time.service";
import { QuickbooksIntegrationService } from "../../quickbooks-integration.service";
import { Company, SharedDataService } from "../../shared-data.service";
import { XeroIntegrationService } from "../../xero-integration.service";
import { ConversationsService } from "../conversations.service";
import { Conversation } from "../panels/conversation.model";
import { MomentModule } from "ngx-moment";
import { ClientTaskCommentsComponent } from "../client-task-comments/client-task-comments.component";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { XeroClientTaskItemComponent } from "./xero-client-task-item/xero-client-task-item.component";
import { NgClass, NgIf } from "@angular/common";

@Component({
    selector: "ch-xero-client-tasks",
    templateUrl: "./xero-client-tasks.component.html",
    styleUrls: ["./xero-client-tasks.component.scss"],
    imports: [
        NgClass,
        NgIf,
        XeroClientTaskItemComponent,
        BsDropdownModule,
        TooltipModule,
        ClientTaskCommentsComponent,
        MomentModule,
    ]
})
export class XeroClientTasksComponent implements OnInit {
  conversation: any = {};
  xeroTrackedItems = [];
  availableAccounts = [];
  selectedTrackedItem: any = null;
  xeroTrackedItemsCounts = {
    unanswered_count: 0,
    to_review_count: 0,
  };

  company: Company = null;
  data = {};

  sub: any;

  loading = false;

  moment_calendar_format = {
    sameDay: "[Today -] h:mm A",
    nextDay: "[Tomorrow]",
    nextWeek: "[Next] dddd",
    lastDay: "[Yesterday -] H:mm A",
    lastWeek: "MMM D - h:mm A",
    sameElse: "MMM D - h:mm A",
  };

  constructor(
    public genericDrawerService: GenericDrawerService,
    public dashboardStore: DashboardStore,
    private localStorageService: LocalStorageService,
    private realTimeService: RealTimeService,
    private workspacesService: WorkspacesService,
    private conversationsService: ConversationsService,
    private dashboardService: DashboardService,
    private xeroService: XeroIntegrationService
  ) {}

  ngOnInit(): void {
    this.data = this.localStorageService.get("data");
    this.workspacesService.$conversation.subscribe((conversation) => {
      this.conversation = conversation;
      if (this.conversation != null) {
        if (this.conversation.id != null) {
          this.realTimeService.setConversationUpdatesListener(
            this.conversation.uuid
          );

          this.realTimeService.conversationUpdates$.subscribe(
            (message: any) => {
              for (let i = 0; i < this.xeroTrackedItems.length; i++) {
                if (
                  this.xeroTrackedItems[i].uuid === message?.tracked_item.uuid
                ) {
                  this.xeroTrackedItems[i] = message.tracked_item;
                  this.xeroTrackedItems[i].integration_data.transaction_body =
                    JSON.parse(
                      message.tracked_item.integration_data.transaction_body
                    );
                  break;
                }
              }
            }
          );

          this.loadXeroTrackedItems();
        }
      }
    });

    this.workspacesService.$company.subscribe((company) => {
      console.log("company on xero client tasks", company);
      this.company = company;

      this.xeroService
        .getAvailableAccountsByCompany(this.company?.id)
        .subscribe((res) => (this.availableAccounts = res.accounts));
    });

    this.sub =
      this.conversationsService.getTrackedItemsTabCountSubject.subscribe(
        (sub) => {
          this.loadXeroTrackedItems();
        }
      );

    this.workspacesService.removeTrackedItem.subscribe((res) => {
      if (res.uuid == this.selectedTrackedItem.uuid) {
        this.selectedTrackedItem = null;
      }

      this.loadXeroTrackedItems();
    });
  }

  ngOnDestroy() {
    if (this.sub != null) {
      this.sub.unsubscribe();
    }
  }

  loadXeroTrackedItems() {
    this.loading = true;
    this.workspacesService
      .get_xero_tracked_items(this.conversation.id, "open")
      .then(
        (res: any) => {
          this.xeroTrackedItems = res.tracked_items;

          this.xeroTrackedItemsCounts = res.counts;
          this.loading = false;
          console.log({ xeroTrackedItems: this.xeroTrackedItems });
        },
        (err) => {
          console.log(err);
          this.loading = false;
        }
      );
  }

  ngAfterViewInit() {}

  selectTrackedItem(tracked_item: any) {
    this.selectedTrackedItem = tracked_item;

    for (let i = 0; i < this.xeroTrackedItems.length; i++) {
      this.xeroTrackedItems[i].selected = false;
    }

    this.selectedTrackedItem.selected = true;
  }

  public openDeleteTrackedItemModal() {
    console.log(this.selectedTrackedItem);
    this.dashboardService.openDeleteTrackedItemModal.next(
      this.selectedTrackedItem
    );
  }

  hasXeroItems() {
    return this.xeroTrackedItems;
  }
}
